import { Component, HostBinding, Inject, inject } from '@angular/core';
import { SnackbarService } from '../shared/services/snackbar.service';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'xp-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss'
})
export class SnackbarComponent {
   
    @HostBinding('class') class = this.data.class
    public displayInfo!: string;
    public displayIcon!: string;
    public iconList: string[] = ["check_circle", "cancel"];
    public isBatchCreated: boolean = true;

    public snackbarInfoElement!: HTMLElement;
    public snackbarIconElement!: HTMLElement;

    constructor(private snackBar: MatSnackBar, private snackbarService: SnackbarService, @Inject(MAT_SNACK_BAR_DATA) public data: any) { }

    ngOnInit(): void {
        this.snackbarInfoElement = document.getElementById("snackbar-info") as HTMLElement;
        this.snackbarIconElement = document.getElementById("snackbar-icon") as HTMLElement;
        this.displayInfo = this.snackbarService._sharedDisplayInfo;
        this.displayIcon = this.snackbarService._sharedDisplayIcon;
        this.snackbarIconElement.style.color = this.snackbarService._sharedDisplayIconColor;
    }

    onClose(): void {
        this.snackBar.dismiss();
    }

}
